import {generateAsyncActionCreators} from '../core/reduxUtils';

const getMerchantInfoActionCreators = generateAsyncActionCreators(
  'GET_MERCHANT_INFO',
  (params) => ({params})
);
const getMerchantInfoByNameActionCreators = generateAsyncActionCreators(
  'GET_MERCHANT_INFO_BY_NAME',
  (params) => ({params})
)
const getMerchantInfoByPostfixActionCreators = generateAsyncActionCreators(
  'GET_MERCHANT_INFO_BY_POSTFIX',
  (params) => ({params})
)

const getMerchantSearchActionCreators = generateAsyncActionCreators(
  'GET_MERCHANT_SEARCH',
  (params) =>({params})
)
const getSuperTabDataActionCreators = generateAsyncActionCreators(
  'GET_SUPER_TAB_DATA',
  (params) =>({params})
)

const getStaticPageActionCreators = generateAsyncActionCreators(
  'GET_STATIC_PAGE_INFO',
  (staticPageId, staticPageKey, params) => ({
    staticPageId,
    staticPageKey,
    params,
  })
);

const actionCreators = {
  getMerchantInfo: {
    ...getMerchantInfoActionCreators,
  },
  getMerchantInfoByName:{
    ...getMerchantInfoByNameActionCreators
  },
  getMerchantInfoByPostfix:{
    ...getMerchantInfoByPostfixActionCreators
  },
  getMerchantSearch:{
    ...getMerchantSearchActionCreators
  },
  getSuperTabData:{
    ...getSuperTabDataActionCreators
  },
  getStaticPage:{
    ...getStaticPageActionCreators
  }
};

export {
  actionCreators,
  getMerchantInfoActionCreators,
  getMerchantInfoByNameActionCreators,
  getMerchantInfoByPostfixActionCreators,
  getMerchantSearchActionCreators,
  getSuperTabDataActionCreators,
  getStaticPageActionCreators
};
